import { CSSProperties } from "react";
import { XCubeSvg } from "./svg";

export const XTroop = ({
  color,
  width,
  style,
}: {
  color?: string;
  width: number;
  style?: CSSProperties;
}) => {
  return <XCubeSvg style={style} width={width} color={color ?? "#A7A7A7"} />;
};
